import { DeliveryMethodEnum } from '@clickersphere/core/enums/DeliveryMethodEnum';

export const deliveryMethodLabelKeys = {
  [DeliveryMethodEnum.NORMAL]: 'birth.deliveryMethod.NORMAL',
  [DeliveryMethodEnum.CESAREAN_SCHEDULED]:
    'birth.deliveryMethod.CESAREAN_SCHEDULED',
  [DeliveryMethodEnum.CESAREAN_EMERGENCY]:
    'birth.deliveryMethod.CESAREAN_EMERGENCY',
  [DeliveryMethodEnum.HOME]: 'birth.deliveryMethod.HOME',
} as const satisfies Record<DeliveryMethodEnum, string>;
